// extracted by mini-css-extract-plugin
export default {"fullWidth":"Label_fullWidth__QVgjf"};